@if (isActive) {
  <topo-modal
    [isActive]="isActive"
    [backgroundCanClose]="true"
    [isCard]="true"
    (close)="close()">
    <div class="modal-header">
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center">
        <h5 class="mx-4 my-4">
          {{
          (configuredChannel?.uId === emptyGuid
          ? 'MANAGEMENT.COMMUNICATION-CENTER.CREATE-CHANNEL'
          : 'MANAGEMENT.COMMUNICATION-CENTER.UPDATE-CHANNEL'
          ) | translate
          }}
        </h5>
        <div
          class="dialog-close"
          (click)="close()">
          <i class="icon icon-close-X"></i>
        </div>
      </div>
    </div>
    <div class="modal-body">
      <form>
        <div class="field">
          <div class="channel-type">{{ configuredChannel?.channelTypeDisplay }}</div>
          <div><img [src]="configuredChannel?.logoImagePath" /></div>
        </div>
        <div class="field">
          <label>{{ 'MANAGEMENT.COMMUNICATION-CENTER.NAME' | translate }}</label>
          <div>
            <input
              class="input is-fullwidth"
              type="text"
              placeholder="{{ 'MANAGEMENT.COMMUNICATION-CENTER.NAME' | translate }}"
              [(ngModel)]="configuredChannel.name"
              name="name" />
          </div>
        </div>
        <div class="field">
          <label>{{ 'MANAGEMENT.COMMUNICATION-CENTER.DESCRIPTION' | translate }}</label>
          <div>
            <textarea
              name="description"
              class="textarea"
              placeholder="{{ 'MANAGEMENT.DATAFEEDS.DESCRIPTION' | translate }}"
            [(ngModel)]="configuredChannel.description"></textarea>
          </div>
        </div>
        @if (!hasDirectMessages || !isNewMode) {
          <div
            class="field"
            fxLayout="row"
            fxLayoutAlign="space-between">
            <label>{{ 'MANAGEMENT.COMMUNICATION-CENTER.SEND-DM' | translate }}</label>
            <div>
              <topo-switch
                [checked]="sendDirectMessages"
                [disabled]="!isNewMode"
              (click)="checkDirectMessage()"></topo-switch>
            </div>
          </div>
        }
        <div class="field">
          <label>{{ 'MANAGEMENT.COMMUNICATION-CENTER.MICROSOFT-TENANT-ID' | translate }}</label>
          <div>
            <input
              class="input is-fullwidth"
              type="text"
              placeholder="{{ 'MANAGEMENT.COMMUNICATION-CENTER.MICROSOFT-TENANT-ID' | translate }}"
              [(ngModel)]="configuredChannel.settings.tenantId"
              name="tenantId" />
          </div>
        </div>
        @if (!isNewMode && !sendDirectMessages) {
          <div
            class="field mt-5">
            <label>{{ 'MANAGEMENT.COMMUNICATION-CENTER.TEAM-GROUP' | translate }}</label>
            <div class="select is-secondary is-medium">
              <select
                [disabled]="sendDirectMessages"
                name="selectedChannelId"
                [(ngModel)]="selectedTeamId"
                (ngModelChange)="selectTeam()">
                @for (teamGroup of teamGroups; track teamGroup.id) {
                  <option
                    [ngValue]="teamGroup.id">
                    {{ teamGroup.name }}
                  </option>
                }
              </select>
            </div>
          </div>
        }
      </form>
    </div>
    <div class="modal-footer">
      <div
        fxLayout="row"
        fxLayoutAlign="end"
        class="mt-4 mb-4">
        <div style="margin-right: 5px">
          <button
            class="button is-secondary"
            (click)="cancelClick()">
            {{ 'MANAGEMENT.COMMUNICATION-CENTER.CANCEL' | translate }}
          </button>
        </div>
        <div>
          <button
            class="button is-primary"
            (click)="saveClick()">
            {{ 'MANAGEMENT.COMMUNICATION-CENTER.SAVE' | translate }}
          </button>
        </div>
      </div>
    </div>
  </topo-modal>
}
